import DashboardApiTableShow, {DashboardColumn} from './DashboardApiTableShow'
import {ListingErrorItem} from './dashboardTableTypes'
import {
  renderDashboardDateTwoLine,
  renderDashboardErrorWithIcon,
  renderDashboardLinkIcon,
  renderDashboardSku,
  renderDashboardStatusPill,
} from './dashboardFormatters'

const columns: DashboardColumn<ListingErrorItem>[] = [
  {header: 'SKU', sortKey: 'sku', render: (item) => renderDashboardSku(item.sku)},
  {header: 'Channel', sortKey: 'channel', render: (item) => item.channel ?? '-'},
  {header: 'Error Message', minWidth: 200, render: (item) => renderDashboardErrorWithIcon(item.error_message)},
  {header: 'Scraped Price', sortKey: 'scraped_price', render: (item) => item.scraped_price ?? '-'},
  {header: 'Product Status', sortKey: 'product_status', render: (item) => renderDashboardStatusPill(item.product_status)},
  {header: 'Type', sortKey: 'type', render: (item) => item.type ?? '-'},
  {header: 'Changed At', sortKey: 'scraped_timestamp', width: 160, render: (item) => renderDashboardDateTwoLine(item.scraped_timestamp)},
  {header: 'Url', width: 120, render: (item) => renderDashboardLinkIcon(item.broken_link)},
]

function LinkErrorsShow() {
  return (
    <DashboardApiTableShow<ListingErrorItem>
      endpoint='linkErrors'
      title='Link Errors'
      columns={columns}
    />
  )
}

export default LinkErrorsShow
